"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processCustomizations = exports.preprocessCustomizations = exports.sumCustomizationsProcessedAmounts = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var big_numbers_1 = require("../../../utils/big-numbers");
var types_1 = require("../types");
var splitCustomizationsByUserChoice = function (customizations) {
    var removedCustomizations = [];
    var addedCustomizations = [];
    customizations.forEach(function (customization, index) {
        customization.index = index;
        if (customization.customizationUserChoice === types_1.PosCustomizationUserChoice.REMOVE) {
            removedCustomizations.push(customization);
        }
        else {
            addedCustomizations.push(customization);
        }
    });
    return { addedCustomizations: addedCustomizations, removedCustomizations: removedCustomizations };
};
var sumCustomizationsTotalPrice = function (posOrderItemCustomizations, digitsRange) {
    return posOrderItemCustomizations
        .reduce(function (sum, customization) { return sum.plus(customization.customizationTotalPrice); }, big_numbers_1.big0)
        .shiftedBy(digitsRange);
};
var sumCustomizationsProcessedAmounts = function (posOrderItemCustomizations) {
    return posOrderItemCustomizations.reduce(function (sum, customization) { return sum.plus(customization.preprocessedTotalPrice); }, big_numbers_1.big0);
};
exports.sumCustomizationsProcessedAmounts = sumCustomizationsProcessedAmounts;
var preprocessCustomizations = function (customizations, digitsRange) {
    // Temp fix to handle order with missing customizationProductOriginalUnitPrice
    customizations.forEach(function (customization) {
        if (!customization.customizationProductOriginalUnitPrice) {
            customization.customizationProductOriginalUnitPrice = customization.customizationUnitPrice;
        }
    });
    // Customers can customize their order by adding or removing products
    var _a = splitCustomizationsByUserChoice(customizations), removedCustomizations = _a.removedCustomizations, addedCustomizations = _a.addedCustomizations;
    var totalRemoved = sumCustomizationsTotalPrice(removedCustomizations, digitsRange).absoluteValue();
    var totalAdded = sumCustomizationsTotalPrice(addedCustomizations, digitsRange);
    // The total of all customisations must be equal to max(totalAdded - totalRemoved, 0)
    // Only the added customizations are converted to products
    // Their price must reduced by the price of the totalRemoved
    // If totalRemoved > totalAdded all customizations must have a 0 price
    if (totalRemoved.isGreaterThanOrEqualTo(totalAdded) || totalAdded.isZero()) {
        return addedCustomizations.map(function (c) { return (__assign(__assign({}, c), { preprocessedTotalPrice: big_numbers_1.big0 })); });
    }
    // Else all added customization prices must be decreased of a total of totalRemoved
    var ratio = totalRemoved.dividedBy(totalAdded);
    var decreaseFactor = big_numbers_1.big1.minus(ratio);
    var preprocessedCustomizations = addedCustomizations.map(function (c) {
        var preprocessedTotalPrice = new bignumber_js_1.default(c.customizationTotalPrice)
            .multipliedBy(decreaseFactor)
            .shiftedBy(digitsRange)
            .integerValue();
        return __assign(__assign({}, c), { preprocessedTotalPrice: preprocessedTotalPrice });
    });
    // The decrease factor enable to dispatch fairly the totalRemoved but there are rounding errors
    // Those errors are corrected by adding the difference to the first customization
    var totalProcessedCustomizations = (0, exports.sumCustomizationsProcessedAmounts)(preprocessedCustomizations);
    preprocessedCustomizations[0].preprocessedTotalPrice = preprocessedCustomizations[0].preprocessedTotalPrice
        .plus(totalAdded)
        .minus(totalRemoved)
        .minus(totalProcessedCustomizations)
        .integerValue();
    return preprocessedCustomizations;
};
exports.preprocessCustomizations = preprocessCustomizations;
var processCustomizations = function (_a) {
    // The parentProductAmount is to be distributed amongst customization based on their share,
    // a share being either:
    // - the customizationProductOriginalPrice of the customization if it is positive
    // - 0 if all the customizationProductOriginalPrices are 0
    // - 0 if the customizationProductOriginalPrice of the customization is negative - it should never append
    var preprocessedCustomizations = _a.preprocessedCustomizations, parentProductAmount = _a.parentProductAmount, parentQuantity = _a.parentQuantity, parentIndex = _a.parentIndex, parentDepth = _a.parentDepth, digitsRange = _a.digitsRange;
    // Then the preprocessedTotalPrice is added to obtain the finalAmount of the customization
    // totalShares = sum of customizationProductOriginalPrices
    var totalShares = preprocessedCustomizations.reduce(function (sum, _a) {
        var customizationProductOriginalUnitPrice = _a.customizationProductOriginalUnitPrice, customizationQuantity = _a.customizationQuantity;
        var customizationProductOriginalPrice = new bignumber_js_1.default(customizationProductOriginalUnitPrice)
            .shiftedBy(digitsRange)
            .multipliedBy(customizationQuantity);
        return customizationProductOriginalPrice.isGreaterThan(big_numbers_1.big0)
            ? sum.plus(customizationProductOriginalPrice)
            : sum;
    }, big_numbers_1.big0);
    var reportedShare = big_numbers_1.big0;
    var customizationsTotalAmount = big_numbers_1.big0;
    var processedCustomizations = preprocessedCustomizations.map(function (customization) {
        var customizationProductSourceId = customization.customizationProductSourceId, customizationQuantity = customization.customizationQuantity, customizationValue = customization.customizationValue, customizationTax = customization.customizationTax, preprocessedTotalPrice = customization.preprocessedTotalPrice, customizationProductOriginalUnitPrice = customization.customizationProductOriginalUnitPrice, customizationSKU = customization.customizationSKU, billingCode = customization.billingCode, purchasePrice = customization.purchasePrice;
        var customizationProductOriginalPrice = new bignumber_js_1.default(customizationProductOriginalUnitPrice)
            .shiftedBy(digitsRange)
            .multipliedBy(customizationQuantity);
        var share = customizationProductOriginalPrice.isGreaterThan(big_numbers_1.big0) ? customizationProductOriginalPrice : big_numbers_1.big0;
        var parentProductAmountShare = share.absoluteValue().multipliedBy(parentProductAmount).plus(reportedShare);
        var customizationAmountParentAmountPart = totalShares.isZero()
            ? big_numbers_1.big0
            : parentProductAmountShare.dividedToIntegerBy(totalShares);
        reportedShare = parentProductAmountShare.minus(customizationAmountParentAmountPart.multipliedBy(totalShares));
        var customizationAmountExtraPart = preprocessedTotalPrice.multipliedBy(parentQuantity);
        var customizationAmount = customizationAmountParentAmountPart.plus(customizationAmountExtraPart);
        customizationsTotalAmount = customizationsTotalAmount.plus(customizationAmount);
        return {
            id: customizationProductSourceId,
            depth: parentDepth + 1,
            quantity: new bignumber_js_1.default(customizationQuantity).multipliedBy(parentQuantity).toNumber(),
            label: customizationValue,
            taxRate: new bignumber_js_1.default(customizationTax).shiftedBy(4).integerValue().toNumber(),
            amount: customizationAmount,
            applyScopeId: "".concat(parentIndex, "-").concat(customization.index, "-").concat(customizationProductSourceId),
            additionalData: customization,
            sku: customizationSKU,
            billingCode: billingCode,
            purchasePrice: purchasePrice && new bignumber_js_1.default(purchasePrice).multipliedBy(100).toNumber(),
        };
    });
    return {
        processedCustomizations: processedCustomizations,
        customizationsTotalAmount: customizationsTotalAmount,
        parentAmountIsSharedOnCustomizations: !totalShares.isZero(),
    };
};
exports.processCustomizations = processCustomizations;
